import { render } from "./MiIcon.vue?vue&type=template&id=191b8801&scoped=true"
import script from "./MiIcon.vue?vue&type=script&lang=js"
export * from "./MiIcon.vue?vue&type=script&lang=js"

import "./MiIcon.vue?vue&type=style&index=0&id=191b8801&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191b8801"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
